import restapi from 'utils/restapi';
import { addLang } from "utils/addLang";

import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  FETCH_CRYPTO_SERVICES_LIST,
  FETCH_CRYPTO_SERVICES_LIST_ERROR,
  CLEAR_FETCH_CRYPTO_SERVICES_LIST,
  FETCH_CRYPTO_LINKS_LIST,
  FETCH_CRYPTO_LINKS_LIST_ERROR,
  CLEAR_FETCH_CRYPTO_LINKS_LIST,
  APPLY_CRYPTO_LINK_DRAG,
  APPLY_CRYPTO_LINK_DRAG_ERROR,
  CLEAR_CRYPTO_LINK_DRAG,
  CREATE_CRYPTO_LINK_SUCCESS,
  CREATE_CRYPTO_LINK_ERROR,
  CLEAR_CREATE_CRYPTO_LINK,
  PATCH_CRYPTO_LINK_SUCCESS,
  PATCH_CRYPTO_LINK_ERROR,
  CLEAR_PATCH_CRYPTO_LINK,
  DELETE_CRYPTO_LINK_SUCCESS,
  DELETE_CRYPTO_LINK_ERROR,
  CLEAR_DELETE_CRYPTO_LINK,
} from 'redux/crypto-links/types';


export const fetchCryptoServicesList = () => baseErrorsHandlerDecorator(
  FETCH_CRYPTO_SERVICES_LIST,
  FETCH_CRYPTO_SERVICES_LIST_ERROR,
  () => restapi.get(addLang('links/crypto_links/crypto_services/')),
  false,
);

export const clearFetchCryptoServicesList = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_CRYPTO_SERVICES_LIST,
  });
};

export const fetchCryptoLinksList = () => baseErrorsHandlerDecorator(
  FETCH_CRYPTO_LINKS_LIST,
  FETCH_CRYPTO_LINKS_LIST_ERROR,
  () => restapi.get(addLang('links/crypto_links/')),
  false,
);

export const clearFetchCryptoLinksList = () => dispatch => {
  dispatch({
    type: CLEAR_FETCH_CRYPTO_LINKS_LIST,
  });
};

export const applyCryptoLinkDrag = formData => baseErrorsHandlerDecorator(
  APPLY_CRYPTO_LINK_DRAG,
  APPLY_CRYPTO_LINK_DRAG_ERROR,
  () => restapi.post(addLang('links/crypto_links/ordering/'), formData),
  false,
  true /* actionSucces */,
);

export const clearCryptoLinkDrag = () => dispatch => {
  dispatch({
    type: CLEAR_CRYPTO_LINK_DRAG,
  });
};

export const createCryptoLink = formData => baseErrorsHandlerDecorator(
  CREATE_CRYPTO_LINK_SUCCESS,
  CREATE_CRYPTO_LINK_ERROR,
  () => restapi.post(addLang('links/crypto_links/'), formData),
  false,
  true /* actionSucces */,
);

export const clearCreateCryptoLink = () => dispatch => {
  dispatch({
    type: CLEAR_CREATE_CRYPTO_LINK,
  });
};

export const patchCryptoLink = (linkId, formData) => baseErrorsHandlerDecorator(
  PATCH_CRYPTO_LINK_SUCCESS,
  PATCH_CRYPTO_LINK_ERROR,
  () => restapi.patch(addLang(`links/crypto_links/${linkId}/`), formData),
  false,
  true /* actionSucces */,
);

export const clearPatchCryptoLink = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_CRYPTO_LINK,
  });
};

export const deleteCryptoLink = linkId => baseErrorsHandlerDecorator(
  DELETE_CRYPTO_LINK_SUCCESS,
  DELETE_CRYPTO_LINK_ERROR,
  () => restapi.delete(addLang(`links/crypto_links/${linkId}/`)),
  false,
  true /* actionSucces */,
);

export const clearDeleteCryptoLink = () => dispatch => {
  dispatch({
    type: CLEAR_DELETE_CRYPTO_LINK,
  });
};
